/* eslint-disable no-console */
import { Lightning } from '@lightningjs/sdk';
import Stamp from '../stamp/stamp.component';
import { PADDING, colors as STAMP_COLORS } from '../stamp/stamp.style';
import { DISPLAY_VARIANT_PRIMARY } from '../stamp/stamp.constants';
import { defaultContext, GAP, getTextTemplate, colors, getInitialStyle } from './incentive.style';
import { ALIGNMENT_HORIZONTAL, ALIGNMENT_VERTICAL, THEME_STAMP, THEME_TEXT } from './incentive.constants';
import { getDisplayVariant, hasValidDisplayVariant } from './incentive.utils';

export default class Incentive extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  _construct() {
    this._style = defaultContext;
    this._childrenLoaded = 0;
  }

  _detach() {
    this.children.forEach(child => {
      child.removeAllListeners('txLoaded');
    });
  }

  set data({ colorMode, incentives, w, linesCount, alignment = ALIGNMENT_HORIZONTAL }) {
    if (!incentives || !incentives.length || !linesCount) {
      if (this.children.length) {
        this.children = [];
      }

      return;
    }

    if (colorMode && colorMode !== this._style.colorMode) {
      this._style = { screenSize: this._style.screenSize, colorMode };
    }

    const wordWrapWidth = w && alignment === ALIGNMENT_HORIZONTAL ? Math.round(w / linesCount) : w;

    const { screenSize, colorMode: mode } = this._style;
    const stampWordWrapWidth = wordWrapWidth - PADDING[screenSize] * 2;
    const children = [];

    // One pass into one array, where the filter/flatMap/map/filter chain built four
    for (let i = 0; i < incentives.length; i += 1) {
      const incentive = incentives[i];

      if (hasValidDisplayVariant(incentive)) {
        const isPrimary = getDisplayVariant(incentive) === DISPLAY_VARIANT_PRIMARY;
        const lines = incentive.lines || [];

        for (let j = 0; j < lines.length; j += 1) {
          const { theme, text } = lines[j];

          if (text && theme === THEME_STAMP) {
            children.push({
              type: Stamp,
              label: text,
              labelColor: STAMP_COLORS.text[mode],
              wordWrapWidth: stampWordWrapWidth,
              backgroundColor: isPrimary ? STAMP_COLORS.primary[mode] : STAMP_COLORS.secondary[mode],
            });
          } else if (text && theme === THEME_TEXT) {
            children.push({
              y: PADDING[screenSize],
              color: colors.text[mode],
              text: {
                ...getTextTemplate(screenSize),
                wordWrapWidth,
                text,
              },
            });
          }
        }
      }
    }

    this.children = children;

    this._childrenLoaded = 0;

    this.children.forEach(child => {
      child.once('txLoaded', () => {
        this._childrenLoaded += 1;
        if (this._childrenLoaded >= this.children.length) {
          this._placeChildren(alignment);
        }
      });
    });
  }

  _placeChildren(alignment = ALIGNMENT_HORIZONTAL) {
    let offset = 0;
    if (alignment === ALIGNMENT_VERTICAL) {
      let w = 0;
      this.children.forEach(child => {
        child.y = offset;
        offset += child.finalH + GAP[this._style.screenSize];
        w = Math.max(w, child.finalW);
      });
      this.children.forEach(child => {
        child.x = Math.round((w - child.finalW) / 2);
      });
      this.patch({ w, h: offset });
    } else {
      this.children.forEach(child => {
        child.x = offset;
        offset += child.finalW + GAP[this._style.screenSize];
      });
      this.w = offset;
    }
  }
}
